// Code-to-user-message map for verifyMagicLink errors. Keys are the
// stable error codes thrown by referrals-server's
// `mapVerifyMagicLinkError`. Unknown codes (or no code at all) fall
// through to the generic message — future server additions degrade
// gracefully without a frontend deploy.
const VERIFY_ERROR_MESSAGES: Record<string, string> = {
  "referrer.auth.magic_link_invalid":
    "This login link is invalid or has expired. Request a new one.",
  "referrer.auth.magic_link_already_used":
    "This login link has already been used. Request a new one.",
  "referrer.auth.referrer_terminated":
    "Your referral account has been terminated. Contact support if you believe this is in error.",
  "referrer.auth.referrer_paused":
    "Your referral account is paused. Contact support to reactivate.",
};

const FALLBACK_MESSAGE =
  "Couldn't verify the login link. Please request a new one.";

export function messageForVerifyError(code: string | undefined): string {
  if (!code) {
    return FALLBACK_MESSAGE;
  }
  return VERIFY_ERROR_MESSAGES[code] ?? FALLBACK_MESSAGE;
}

export const VERIFY_ERROR_FALLBACK = FALLBACK_MESSAGE;
